import { createContainer } from 'unstated-next'

import { AnalyticsContext } from '../../types/figs'

const useHeapAttributesImpl = (props: AnalyticsContext | undefined) => {
  return props
}

const HeapAttributesContainer = createContainer(useHeapAttributesImpl)
export const HeapAttributesProvider = HeapAttributesContainer.Provider
export const useHeapAttributes = (): AnalyticsContext => {
  const attributesFromContext = HeapAttributesContainer.useContainer()
  return (
    attributesFromContext ?? {
      category: 'Unknown',
    }
  )
}
